import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const authzPermissionMenuRegistry = {
    core_authzPermission: {
        label: "Authz Permission",
        link: PAGE_URL.AUTHZ_PERMISSION_PAGE,
        key: PAGE_URL.AUTHZ_PERMISSION_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default authzPermissionMenuRegistry;
